import type { SVGProps } from 'react';

const SvgRaApprovalRequested = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11.69 20.898H8c-1.65 0-3-1.35-3-3v-8.32c0-1.38.73-2.69 1.91-3.41l4.53-2.76c.94-.57 2.07-.6 3.03-.06A2.97 2.97 0 0 1 16 5.968v4.91l.26-.22c1.03-.85 2.51-.79 3.46.16.93.93 1.01 2.39.19 3.42l-1.28 1.36-4.11 4.13c-.75.75-1.78 1.18-2.84 1.18zm1.3-15.94c-.16 0-.33.04-.52.15l-4.52 2.76a2.01 2.01 0 0 0-.96 1.71v8.32c0 .55.45 1 1 1h3.69c.54 0 1.04-.21 1.42-.59l5.29-5.39c.13-.16.11-.49-.1-.69a.557.557 0 0 0-.76-.03l-1.08.9c-.46.38-1.07.45-1.6.21-.53-.25-.86-.77-.86-1.36v-5.98c0-.53-.36-.79-.51-.87-.09-.05-.27-.13-.5-.13z"
    />
  </svg>
);
export default SvgRaApprovalRequested;
